import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
import Modal from "react-modal";

const FieldOfficerTransferForm = (props) => {
  const frmRef = useRef({});
  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);
  const [loading, setLoading] = useState(false);
  const [employeelist, setEmployeelist] = useState(null);
  const [assignEmployeeId, setAssignEmployeeId] = useState();
  const [seasonlist, setSeasonlist] = useState(null);
  const [selectedSeasonId, setSelectedSeasonId] = useState();

  const [vehiclelist, setVehiclelist] = useState(null);
  const [vmerId, setvmerId] = useState();

  const [isVehicleSelected, setIsVehicleSelected] = useState(false);

  const [driverName, setDriverName] = useState();
  const [driverContact, setDriverContact] = useState();
  const [startMeter, setStartMeter] = useState();
  const [endMeter, setEndMeter] = useState();

  const [productData, setProductData] = useState([]);
  const [productId, setProductId] = useState(0);

  const [availableAmount, setavailableAmount] = useState();
  const [unitId, setunitId] = useState();

  const [decimalPattern, setDecimalPattern] = useState(
    localStorage.getItem("decimalPattern")
  );
  const [integerPattern, setIntegerPattern] = useState(
    localStorage.getItem("integerPattern")
  ); // ;

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 40,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "900px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  const { sendRequest: postProcurementOfficer } = useHttp();

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const currentDate = new Date().toISOString().slice(0, 10);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Format hours and minutes with leading zeros if necessary
    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
        //url: `/api/getEmps/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("emp", data.output);
        setEmployeelist(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getSeason } = useHttp();
  useEffect(() => {
    getSeason(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // console.log("season", data);
        setSeasonlist(data);
      }
    );
  }, [getSeason]);

  const { sendRequest: getVehicle } = useHttp();
  useEffect(() => {
    getVehicle(
      {
        url: "/api/vehicleMachineEquipRegistratn/",
      },
      (res) => {
        if (res) {
          var vehicle = res.filter((x) => x.vmeClassific == "Vehicle");
          //console.log(vehicle);
          setVehiclelist(vehicle);
        }
      }
    );
  }, [getEmp]);

  const { sendRequest: getproduct } = useHttp();

  const getProductDetail = () => {
    getproduct(
      {
        url: "/api/productNonService/",
      },
      (res) => {
        if (res) {
          //console.log("product", res);
          setProductData(res);
        }
      }
    );
  };

  useEffect(() => {
    getProductDetail();
  }, [getproduct]);

  const { sendRequest: getAvailableStock } = useHttp();

  const loadStockData = (id) => {
    productRef.current.productSubType.value = "";
    productRef.current.productType.value = "";

    var itemlist = productData.filter((item) => item.productId == id);
    var selectedItem = itemlist[0];

    productRef.current.productSubType.value = selectedItem.productSubTypeName;
    productRef.current.productType.value = selectedItem.productTypeName;
    const data = {
      warehouseId: localStorage.getItem("warehouseId"),
      productId: id,
    };

    getAvailableStock(
      {
        url: "/api/getAvailableStock/",
        method: "POST",
        body: data,
      },
      (myres) => {
        console.log("API RESPONSE", myres);

        const res = myres || {};

        productRef.current.availableQuantity.value =
          res.availableQty ?? "";

        productRef.current.productUnit.value =
          res.unitAbbreviation || res.unitName || "";

        productRef.current.unitId.value =
          res.unitId ?? "";

        productRef.current.availableAmount.value =
          res.availableAmount ?? 0;

        setavailableAmount(res.availableAmount ?? 0);
        setunitId(res.unitId ?? 0);
      }
    );
  };

  const LoadVehicleData = (id) => {
    if (id > 0) {
      var itemlist = vehiclelist.filter((item) => item.vmerId == id);

      setIsVehicleSelected(true);

      var selectedItem = itemlist[0];

      setDriverName(itemlist[0].assignedPersonDriverName);
      setDriverContact(itemlist[0].assignedPersonContactNo);
    } else {
      setDriverName("");
      setDriverContact("");
      setStartMeter("");
      setEndMeter("");
      setIsVehicleSelected(false);
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (productDetails.length == 0) {
      toast.success("Please enter at least one product!");
      return;
    }

    setLoading(true);

    const data = {
      goodsTransferDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
      goodsTransferToOfficerEmpId: assignEmployeeId,
      seasonId: selectedSeasonId,
      timeStamp: frmRef.current.time_stamp.value,
      productDetails: productDetails,
      goodsTransferType: "User",
      vehicleId: vmerId,
      goodsTransferFromWarehouseId: localStorage.getItem("warehouseId"),
      driverName: driverName || " ",
      driverContactNo: driverContact || " ",
      startMeterReading: startMeter || " ",
      endMeterReading: endMeter || " ",
      remark: frmRef.current.remark.value,
      status: 1,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      serviceId: props.sId,
    };
    //console.log("data", data);
    if (props.update) {
      data["gtProcurementId"] = props.update.gtProcurementId;
    }
    postProcurementOfficer(
      {
        url: "/api/procurementOfficer/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        toast.success(
          `Procurement officer goods transfer note ${props.update ? "updated" : "added!"
          }`
        );
        props.addForm(false);
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    if (props.update) {
      frmRef.current.date.value = moment(props.update.gtProcurementDate).format(
        "YYYY-MM-DD"
      );
      frmRef.current.emp_id.value = props.update.procurementOfficerEmpId;
      frmRef.current.time_stamp.value = moment(
        props.update.timeStamp,
        "HH:mm"
      ).format("hh:mm");
      setProductDetails(props.update.productDetails);
      frmRef.current.gate_pass_id.value = props.update.gatepassId;
      frmRef.current.vehicle_id.value = props.update.vehicleId;
      setDriverName(props.update.driverName);
      setDriverContact(props.update.driverContactNo);
      startMeter(props.update.startMeterReading);
      endMeter(props.update.endMeterReading);
      frmRef.current.remark.value = props.update.remark;
    }
  }, [props.update]);

  const submitProduct = (e) => {
    e.preventDefault();
    console.log("productId", productId);
    if (productId === 0) {
      toast.error("Please select the product name");
      return;
    }
    var itemlist = productData.filter((item) => item.productId == productId);
    var selectedItem = itemlist[0];

    var productId1 = productId;
    var itemId = selectedItem.itemId;
    var productName = selectedItem.productName;
    var productSubType = productRef.current.productSubType.value;
    var productType = productRef.current.productType.value;
    var availableQuantity = productRef.current.availableQuantity.value;
    var unit = productRef.current.productUnit.value;
    var unitId1 = unitId;
    var availableAmount1 = availableAmount;
    var itemQuantity = productRef.current.itemQuantity.value;
    var pdlist = productDetails.filter((item) => item.productId == productId1);

    if (parseFloat(itemQuantity ?? 0) <= 0) {
      toast.success("Please enter product quantity", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    if (pdlist.length != 0) {
      toast.success("Product already present into the list", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    setProductDetails((x) => [
      ...x,
      {
        srno:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,
        productId: productId1,
        itemId: itemId,
        productName: productName,
        productSubType: productSubType,
        productType: productType,
        availableQuantity: availableQuantity,
        unit: unit,
        unitId: unitId1,
        availableAmount1: availableAmount1,
        itemQuantity: itemQuantity,
        itemQuantityBal: itemQuantity,
        productCost: 0,
        remark: frmRef.current.remark.value,
        status: 1,
        createdBy: parseInt(localStorage.getItem("id")),
        orgId: localStorage.getItem("orgId"),
        // itemType: productRef.current.itemType.value,
        // itemCategory: productRef.current.itemCategory.value,
        // itemQuantity: productRef.current.itemQuantity.value,
        // unit: productRef.current.unit.value,
        // itemUnitPrice: productRef.current.itemUnitPrice.value,
        // rate: productRef.current.rate.value,
        // currency: productRef.current.currency.value,
        // totalAmount: productRef.current.totalAmount.value,
      },
    ]);

    setProductId(0);

    productRef.current.productSubType.value = "";
    productRef.current.productType.value = "";
    productRef.current.availableQuantity.value = "";
    productRef.current.productUnit.value = "";
    setunitId(0);
    setavailableAmount(0);
    productRef.current.itemQuantity.value = "0";
    //console.log(productDetails);
  };
  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  const handleValidateQuantityChange = (event) => {
    var validator = new RegExp("^[0-9.]*$");

    var qtyvalid = validator.test(event.target.value);
    //console.log("handleValidateQuantityChange");
    //console.log(qtyvalid);
    if (qtyvalid) {
      var quantity = parseFloat(event.target.value);

      var totalquantity = parseFloat(
        productRef.current.availableQuantity.value
      );

      if (quantity > totalquantity) {
        event.target.value = 0;
        toast.success("Please enter quanitty less than total quantity", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } else {
      event.target.value = 0;
    }
  };

  return (
    <>
      <Modal isOpen={close} style={customModalStyles}>
        <div className="">
          <div>
            <div className="">
              <div className="">
                <h3 className="card-title">Product Details</h3>
                <div className="card-tools text-right">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setClose(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                  <hr />
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-md-3">
                {" "}
                <label htmlFor={"productId"}> Product Name</label>
                <select
                  id="productId"
                  className="form-control"
                  ref={(el) => (frmRef.current["productId"] = el)}
                  value={productId}
                  onChange={(e) => {
                    var _productId = 0;
                    if (e.target.value != "--Select Product Name--") {
                      _productId = e.target.value;
                    }
                    setProductId(_productId);
                    loadStockData(_productId);
                  }}
                >
                  <option>--Select Product Name--</option>
                  {productData &&
                    productData.map((x) => (
                      <option
                        key={x.productId}
                        product-id={x.productId}
                        value={x.productId}
                      >
                        {x.productName + "(" + x.itemId + ")"}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-3">
                {" "}
                <label htmlFor={"productId"}> Product SubType </label>{" "}
                <input
                  type={"input"}
                  id={"itemType"}
                  readOnly
                  ref={(el) => (productRef.current["productSubType"] = el)}
                  className="form-control"
                />{" "}
              </div>
              <div className="col-md-3">
                <label htmlFor={"productId"}> Product Type </label>{" "}
                <input
                  type={"input"}
                  id={"productType"}
                  readOnly
                  ref={(el) => (productRef.current["productType"] = el)}
                  className="form-control"
                />{" "}
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-md-3">
                {" "}
                <label htmlFor={"Available"}> Available Quantity</label>
                <input
                  type={"input"}
                  id={"itemType"}
                  readOnly
                  ref={(el) => (productRef.current["availableQuantity"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                {" "}
                <label htmlFor={"unit"}> Unit</label>
                <input
                  type={"input"}
                  id={"itemType"}
                  readOnly
                  ref={(el) => (productRef.current["productUnit"] = el)}
                  className="form-control"
                />
                <input
                  name="hiddenInput"
                  value=""
                  type="hidden"
                  ref={(el) => (productRef.current["unitId"] = el)}
                />
                <input
                  name="hiddenInput"
                  value=""
                  type="hidden"
                  ref={(el) => (productRef.current["availableAmount"] = el)}
                />
              </div>
              <div className="col-md-3">
                <label htmlFor={"unit"}> Item Quantity</label>
                <input
                  type={"input"}
                  id={"itemType"}
                  ref={(el) => (productRef.current["itemQuantity"] = el)}
                  className="form-control"
                  pattern={decimalPattern}
                  onChange={(e) => {
                    handleValidateQuantityChange(e);
                  }}
                />
              </div>
              <br />
              <div className="col-md-3">
                {" "}
                <button
                  className="btn btn-success mx-2 my-2"
                  onClick={submitProduct}
                >
                  +
                </button>{" "}
              </div>
            </div>

            <hr />

            <div className="">
              <table className="table table-bordered table-responsive">
                <thead>
                  <tr className="tableheaderrow mb-2view">
                    <th>Sr. No</th>
                    <th>Item Id</th>
                    <th>Product Name</th>

                    <th>Item SubType</th>
                    <th>Item Type</th>
                    <th>Available Quantity</th>
                    <th>Unit</th>
                    <th>Item Quantity</th>
                    <th>Unit</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {productDetails &&
                    productDetails.map((itm, i) => {
                      return (
                        <tr key={i.srno}>
                          <td>{itm.srno}</td>
                          <td>{itm.itemId}</td>
                          <td>{itm.productName}</td>
                          <td>{itm.productSubType}</td>
                          <td>{itm.productType}</td>
                          <td>{itm.availableQuantity}</td>
                          <td>{itm.unit}</td>
                          <td>{itm.itemQuantity}</td>
                          <td>{itm.unit}</td>
                          {/* <td>{itm.totalAmount}</td> */}
                          <td>
                            {" "}
                            <button
                              className="btn"
                              onClick={(e) => handleDelete(i, e)}
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>

            <div className="row mb-2">
              <div className="col-md-3"></div>
              <div className="col-md-2"></div>

              <div className="col-md-2">
                <button
                  className="btn  btn-primary mx-2 my-2"
                  onClick={() => {
                    productDetails.map((x) => (x["isSave"] = true));
                    setClose(false);
                  }}
                >
                  Save
                </button>
              </div>
              <div className="col-md-3"></div>
            </div>
          </div>
        </div>
      </Modal>

      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">
                    Add Field officer Goods Transfer
                  </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-2">
                      <label htmlFor={"date"}>{"Date "}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>

                    <div className="col-md-2">
                      <label htmlFor={"time_stamp"}>{"TimeStamp"}</label>
                      <input
                        type={"time"}
                        id={"time_stamp"}
                        required
                        ref={(el) => (frmRef.current["time_stamp"] = el)}
                        className="form-control"
                        defaultValue={getCurrentTime()}
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"emp_id"}>
                        {"Procurement officer Employee"}
                      </label>
                      <select
                        id="emp_id"
                        className="form-control"
                        required
                        ref={(el) => (frmRef.current["assignEmployeeId"] = el)}
                        value={assignEmployeeId}
                        onChange={(e) => {
                          setAssignEmployeeId(e.target.value);
                        }}
                      >
                        <option selected disabled value="">
                          --Select Employee--
                        </option>
                        {employeelist &&
                          employeelist.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"emp_id"}>{"Season"}</label>
                      <select
                        id="season_id"
                        className="form-control"
                        required
                        ref={(el) => (frmRef.current["selectedSeasonId"] = el)}
                        value={selectedSeasonId}
                        onChange={(e) => {
                          setSelectedSeasonId(e.target.value);
                        }}
                      >
                        <option selected disabled value="">
                          Select Season
                        </option>
                        {seasonlist &&
                          seasonlist.map((x) => (
                            <option
                              key={x.seasonId}
                              employee-id={x.seasonId}
                              value={x.seasonId}
                            >
                              {x.seasonName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-4">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      <button
                        className="btn btn-sm btn-success mx-2 my-2"
                        formNoValidate="True"
                        disabled={!assignEmployeeId}
                        onClick={(e) => {
                          if (!assignEmployeeId) return;
                          e.preventDefault(false);
                          productDetails &&
                            setProductDetails((items) =>
                              items.filter((x) => x.isSave)
                            );
                          setClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"vehicle_id"}>{"Vehicle id"}</label>
                      <select
                        id="vmerId"
                        className="form-control"
                        ref={(el) => (frmRef.current["vmerId"] = el)}
                        value={vmerId}
                        onChange={(e) => {
                          setvmerId(e.target.value);
                          LoadVehicleData(e.target.value);
                        }}
                      >
                        <option value="">--Select Vehicle --</option>
                        {vehiclelist &&
                          vehiclelist.map((x) => (
                            <option
                              key={x.vmerId}
                              vmer-id={x.vmerId}
                              value={x.vmerId}
                            >
                              {x.vmeNo}
                            </option>
                          ))}
                      </select>
                    </div>
                    {isVehicleSelected && (
                      <div className="col-md-4">
                        <label htmlFor={"driverName"}>{"Driver Name"}</label>
                        <input
                          type={"text"}
                          id={"driverName"}
                          required
                          //ref={(el) => (frmRef.current["driverName"] = el)}

                          className="form-control"
                          value={driverName}
                          onChange={(e) => setDriverName(e.target.value)}
                        />
                      </div>
                    )}
                  </div>

                  <div className="row mb-2">
                    {isVehicleSelected && (
                      <>
                        <div className="col-md-4">
                          {" "}
                          <label htmlFor={"driverContactNo"}>
                            {"Vehicle Driver Contact Number"}
                          </label>
                          <input
                            type={"text"}
                            id={"driverContactNo"}
                            required
                            // ref={(el) =>
                            //   (frmRef.current["driverContactNo"] = el)
                            // }
                            className="form-control"
                            value={driverContact}
                            onChange={(e) => setDriverContact(e.target.value)}
                          />
                        </div>
                        <div className="col-md-4">
                          {" "}
                          <label htmlFor={"startMeterReading"}>
                            {"Start Meter Reading"}
                          </label>
                          <input
                            type={"text"}
                            id={"startMeterReading"}
                            required
                            value={startMeter}
                            onChange={(e) => setStartMeter(e.target.value)}
                            className="form-control"
                          />
                        </div>
                        <div className="col-md-4">
                          <label htmlFor={"endMeterReading"}>
                            {"End Meter Reading"}
                          </label>
                          <input
                            type={"text"}
                            id={"endMeterReading"}
                            required
                            value={endMeter}
                            onChange={(e) => setEndMeter(e.target.value)}
                            className="form-control"
                          />{" "}
                        </div>
                      </>
                    )}
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default FieldOfficerTransferForm;
